import React from 'react';
import { Alert } from 'reactstrap';

const ALERT_BY_REASON = {
  awaiting: {
    title: 'Belum dapat Dimulai',
    getDescription: featureLabel =>
      `Dikarenakan proses tender belum memasuki waktu closing date. ${featureLabel} tidak dapat diakses sampai tanggal penutupan yang ditentukan tercapai.`,
  },
  'not-started': {
    title: 'Mulai Proses Evaluasi',
    getDescription: featureLabel =>
      `Klik tombol Start Tender Evaluation untuk memulai dan mengakses ${featureLabel}.`,
  },
  'improvement-closing': {
    title: 'Belum dapat Dimulai',
    getDescription: featureLabel =>
      `Dikarenakan proses improvement belum melewati Closing Date Improvement. ${featureLabel} tidak dapat diakses sampai Closing Date Improvement tercapai.`,
  },
};

const TenderNotClosedAlert = ({ featureLabel, reason = 'awaiting' }) => {
  const copy = ALERT_BY_REASON[reason] || ALERT_BY_REASON.awaiting;

  return (
    <Alert
      color='danger'
      className='d-flex align-items-center justify-content-between gap-3'
    >
      <div className='d-flex align-items-start gap-2'>
        <i className='ri-information-line fs-20 mt-1'></i>
        <div>
          <h5 className='alert-heading fs-14 fw-bold mb-1'>{copy.title}</h5>
          <p className='mb-0 fs-13'>{copy.getDescription(featureLabel)}</p>
        </div>
      </div>
    </Alert>
  );
};

export default TenderNotClosedAlert;
